import { render, staticRenderFns } from "./Form14CaseInformation.vue?vue&type=template&id=51a87c74&scoped=true"
import script from "./Form14CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form14CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a87c74",
  null
  
)

export default component.exports